<template>
      <BContainer class="p-mobile container-pages" v-if="imagesDisplay">
        <BRow>
          <BCol>
            <BCarousel
              v-if="imagesDisplay.length > 0"
              id="carousel-no-animation"
              style="text-shadow: 0px 0px 2px #000"
              no-animation
              :interval="0"
              controls
              indicators
              >
                <BCarouselSlide  v-for="(image, i) in imagesDisplay" :key="image.id"
                 :caption="titleToString(i)"
                  :img-alt="`${alt} – slika ${i + 1}`"
                  :img-src="$getImageSrc(image.medium)">
               </BCarouselSlide>    
            </BCarousel>
            <img v-else :src="require('~/assets/logo/noimage.webp')" alt="Cene na pijacama">
          </BCol>
        </BRow>
      </BContainer>
  
</template>
  
  <script setup>
import { BContainer, BRow, BCol, BCarousel, BCarouselSlide } from 'bootstrap-vue-next';

import { useAdvertisementStore } from "~/stores/advertisement";

const useStore = useAdvertisementStore();

import { useCustomerLoginStore } from "~/stores/login/customer";

const useStoreCustomer = useCustomerLoginStore();
  
  
  const props = defineProps({
      images:{
          required: true,
          type : Array
      },
      // opis slike (naziv oglasa i mesto)
      alt: {
          type: String,
          default: 'Oglas'
      },

  })
  
  const imagesDisplay = ref([]);

  const titleToString = (i) => {

    return i + 1
  }

  watchEffect(() => {
    imagesDisplay.value = props.images
  })
  </script>
  
  <style>
  
  </style>
